module.exports = __webpack_public_path__ + "img/移动端成功.3afaab1b.png";